<mat-slide-toggle
  [checked]="validateRS"
  (change)="onValidateRSChange($event.checked)"
>
  Check for Rad Survey Required
</mat-slide-toggle>
